import * as React from 'react';
import withStyles, { StyledComponentProps } from 'react-jss';
import stylesheet from 'src/constants/stylesheet';
import IsTouch from 'src/utils/IsTouch';
import { Language } from 'src/utils/Languages';
import { Subtract } from 'utility-types';
import { InjectedApiProps, withApi } from './Api';

const rotate = {
    from: {
        transformOrigin: 'center',
        transform: `translate3d(-50%,-50%,0) rotate3d(0, 0, 1, 0)`
    },
    to: {
        transformOrigin: 'center',
        transform: `translate3d(-50%,-50%,0) rotate3d(0, 0, 1, 360deg)`,
    }
};

const styles = {
    container: IsTouch ? { display: 'none' } : {
        position: 'fixed',
        top: 0,
        left: 0,
        width: 0,
        height: 0,
        zIndex: 99999,
        transform: 'translate3d(-1000px,-1000px,0)',
        pointerEvents: 'none'
    },
    cursorDefault: {
        position: 'absolute',
        // top: "-0.25rem",
        // left: "-0.25rem",
        top: "50%",
        left: "50%",
        transition: 'opacity linear 0.2s',
        opacity: 0,
        display: 'block',
        transform: 'translate3d(-50%,-50%,0)',
        width: "0.5rem",
        height: "0.5rem",
        borderRadius: "50%",
        background: '#000',
        border: 'none',
        "*[data-cursor='default'] &": {

            opacity: 1,
        },
    },
    cursorLink: {
        position: 'absolute',
        // top: "-1rem",
        // left: "-1rem",
        top: "50%",
        left: "50%",
        transition: 'transform linear 0.2s',
        borderRadius: "50%",
        border: '1px solid black',
        background: '#000',
        width: ".835rem",
        height: ".835rem",
        opacity: 0,
        display: 'block',
        transform: 'translate3d(-50%,-50%,0) scale(0.2)',
        "*[data-cursor='link'] &": {
            transform: 'translate3d(-50%,-50%,0) scale(1)',
            opacity: 1,
        },
    },
    cursorArrowLeft: {
        position: 'absolute',
        // top: "-0.75rem",
        // left: "-0.75rem",
        top: "50%",
        left: "50%",
        transition: 'opacity linear 0.2s',
        width: "1.5rem",
        height: "1.5rem",
        display: 'block',
        borderRight: '1px solid black',
        borderBottom: '1px solid black',
        opacity: 0,
        strokeLinecap: 'round',
        transform: 'translate3d(-50%,-50%,0) scale(0.2) rotate3d(0,0,1,135deg)',

        "*[data-cursor='previous'] &": {
            transform: 'translate3d(-50%,-50%,0) scale(1) rotate3d(0,0,1,135deg)',
            opacity: 1,
        }
    },
    cursorArrowRight: {
        position: 'absolute',
        // top: "-0.75rem",
        // left: "-0.75rem",
        top: "50%",
        left: "50%",
        transition: 'opacity linear 0.2s',
        width: "1.5rem",
        height: "1.5rem",
        display: 'block',
        borderRight: '1px solid black',
        borderBottom: '1px solid black',
        opacity: 0,
        strokeLinecap: 'round',
        transform: 'translate3d(-50%,-50%,0) scale(0.2) rotate3d(0,0,1,-45deg)',

        "*[data-cursor='next'] &": {
            transform: 'translate3d(-50%,-50%,0) scale(1) rotate3d(0,0,1,-45deg)',
            opacity: 1,

        }
    },
    cursorProjects: {
        position: 'absolute',
        // top: "-0.25rem",
        // left: "-0.25rem",
        top: "50%",
        left: "50%",
        transition: 'opacity linear 0.2s',
        opacity: 0,
        display: 'block',
        transform: 'translate3d(-50%,-50%,0)',
        width: "0.8rem",
        height: "0.8rem",
        borderRadius: "50%",
        background: '#000',

        "&:after": {
            position: 'absolute',
            left: '100%',
            top: '50%',
            transform: 'translateY(-50%)',
            display: 'block',
            ...stylesheet.SmallText,
            color: 'black',
            whiteSpace: 'nowrap',
            marginLeft: 5
        },

        "*[data-cursor='nextProject'] &": {
            "&:after": {
                content: Language === 'en' ? "'Next project'" : "'Projet suivant'",
            },

            opacity: 1,
        },

        "*[data-cursor='previousProject'] &": {
            "&:after": {
                content: Language === 'en' ? "'Previous project'" : "'Projet précédent'",
            },

            opacity: 1,
        },
    },

    cursorLoading: {
        position: 'absolute',
        // top: "-0.75rem",
        // left: "-0.75rem",
        top: "50%",
        left: "50%",
        transition: 'transform linear 0.2s',
        borderRadius: "50%",
        border: '1px solid black',
        borderTopColor: 'transparent',
        background: 'transparent',
        width: ".8rem",
        height: ".8rem",
        opacity: 0,
        display: 'block',
        transform: 'translate3d(-50%,-50%,0) scale(0.1)',

        "*[data-cursor='loading'] &": {
            transform: 'translate3d(-50%,-50%,0) scale(1)',
            opacity: 1,
            animationName: 'rotate',
            animationIterationCount: 'infinite',
            animationDuration: '1s',
            animationTimingFunction: 'linear',
        }
    },
    '@keyframes rotate': rotate
};
export type CursorType = 'loading' | 'next' | 'previous' | 'default' | 'link' | 'nextProject' | 'previousProject';

export type Cursor = {
    type: CursorType;
    setType: (type: CursorType) => void;
    // loading: (isLoading: boolean) => void;
};

const initState: Cursor = {
    type: 'default',
    setType: 0 as never,
    // loading: 0 as never
}

const CursorReactContext = React.createContext<Cursor>(initState);

export type CursorProdiverProps = {};
type Props =
    CursorProdiverProps &
    InjectedApiProps &
    StyledComponentProps<keyof typeof styles>;

type State = {
    isLoading?: boolean;

} & Cursor;
class CursorProvider extends React.Component<Props, State> {
    private cursor: React.RefObject<HTMLDivElement> = React.createRef();

    private observer: MutationObserver;
    constructor(props: Props) {
        super(props);

        this._follow = this._follow.bind(this);
        this._setLink = this._setLink.bind(this);
        this._setDefault = this._setDefault.bind(this);
        this._addLink = this._addLink.bind(this);
        this._CheckElements = this._CheckElements.bind(this);

        this.state = {
            type: 'default',
            isLoading: this.props.apiCtx.loading,
            setType: this._setType.bind(this),
            // loading: this._loading.bind(this)
        };
    }
    componentDidMount() {
        window.addEventListener("mousemove", this._follow);
        const html = document.querySelector("html")!;
        html.classList.add("no-cursor");

        this.observer = new MutationObserver((mutations) => {
            // For the sake of...observation...let's output the mutation to console to see how this all works
            mutations.forEach((mutation) => {
                mutation.addedNodes.forEach(this._CheckElements);
            });
        });

        const observerConfig = {
            childList: true,
            subtree: true
        };

        const targetNode = document.body;

        this.observer.observe(targetNode, observerConfig);

        this._CheckElements(targetNode);
    }

    componentDidUpdate(prevProps: Props, prevState: State) {
        if (prevState.type !== this.state.type ||
            prevState.isLoading !== this.state.isLoading) {
            this._refreshCursor();
        }
        if (prevProps.apiCtx.loading !== this.props.apiCtx.loading) {
            this.setState(() => ({ isLoading: this.props.apiCtx.loading }));
        }
    }

    componentWillUnmount() {
        window.removeEventListener("mousemove", this._follow);
        const html = document.querySelector("html")!;
        html.classList.remove("no-cursor");

        this.observer.disconnect();
    }

    public render() {
        const { classes } = this.props;
        return (
            <CursorReactContext.Provider value={this.state}>
                <div
                    className={classes!.container}
                    ref={this.cursor}
                >
                    <span className={classes!.cursorDefault} />
                    <span className={classes!.cursorLink} />
                    <span className={classes!.cursorArrowRight} />
                    <span className={classes!.cursorArrowLeft} />
                    <span className={classes!.cursorProjects} />
                    <span className={classes!.cursorLoading} />

                </div>
                {this.props.children}
            </CursorReactContext.Provider>
        );
    }

    private _setType(type: CursorType) {
        this.setState(() => ({ type }));
    }
    // private _loading(isLoading: boolean) {
    //     this.setState(() => ({ isLoading }));
    // }

    private _refreshCursor() {
        const { current } = this.cursor;
        if (!current) { return }
        const { type, isLoading } = this.state;

        current.dataset.cursor = isLoading ? 'loading' : type;
    }

    private _setLink() {
        const { current } = this.cursor;
        if (!current) { return }

        current.dataset.cursor = 'link';
    }

    private _setDefault() {
        const { current } = this.cursor;
        if (!current) { return }

        current.dataset.cursor = 'default';
    }

    private _follow(ev: MouseEvent) {
        const { current } = this.cursor;
        if (!current) { return }
        current.style.transform = `translate3d(${ev.clientX}px,${ev.clientY}px,0)`;
    }

    private _addLink(a: HTMLElement) {
        if (a.dataset.cursor) { return; }
        a.dataset.cursor = "true";
        a.addEventListener("mouseenter", this._setLink);
        a.addEventListener("mouseleave", this._setDefault);
    }

    private _CheckElements(node: Node) {

        if (!(node instanceof HTMLElement)) { return; }
        node.querySelectorAll("a").forEach(this._addLink);
        if (node.tagName.toLowerCase() === "a") {
            this._addLink(node as HTMLAnchorElement);
        }
    }

}

export type InjectedCursorProps = { cursor: Cursor };
export const withCursor =
    <OriginalProps extends InjectedCursorProps>(
        Component: React.ComponentType<OriginalProps>
    ): React.FunctionComponent<Subtract<OriginalProps, InjectedCursorProps>> => {

        return (props: Subtract<OriginalProps, InjectedCursorProps>) => {
            return (
                <CursorReactContext.Consumer>
                    {(cursor) =>
                        <Component {...{ ...(props as object), cursor } as OriginalProps} />}
                </CursorReactContext.Consumer>
            );
        };

    };

export default withApi(withStyles(styles)(CursorProvider));


// WEBPACK FOOTER //
// ./src/_context/Cursor.tsx